import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/home';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-heart-pulse-line text-xl text-primary-500"></i>
                </div>
                <span className="text-lg font-heading text-foreground-800">{siteInfo.name}</span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                {siteInfo.tagline}
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="小红书">
                  <i className="ri-chat-smile-2-line text-lg"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-heading text-foreground-800 mb-4">内容分类</h4>
              <ul className="space-y-2">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-heading text-foreground-800 mb-4">快速链接</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
                </li>
                <li>
                  <Link to="/category/buru-yuer" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">哺乳育儿</Link>
                </li>
                <li>
                  <Link to="/category/kepu-manhua" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">科普漫画</Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">关于我们</Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-heading text-foreground-800 mb-4">联系我们</h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-2">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                    <i className="ri-mail-line text-sm text-primary-500"></i>
                  </div>
                  <span className="text-sm text-foreground-600">{siteInfo.email}</span>
                </li>
                <li className="flex items-start gap-2">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                    <i className="ri-phone-line text-sm text-primary-500"></i>
                  </div>
                  <span className="text-sm text-foreground-600">{siteInfo.phone}</span>
                </li>
                <li className="flex items-start gap-2">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                    <i className="ri-map-pin-line text-sm text-primary-500"></i>
                  </div>
                  <span className="text-sm text-foreground-600">{siteInfo.address}</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-background-200/70 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              © {new Date().getFullYear()} {siteInfo.name} 版权所有 | 京ICP备2024XXXXXX号
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">用户协议</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}